/**
 * Toggle's the submenu when the user clicks on a parent menu link item,
 * when clicking somewhere else it hides the submenu again.
 */

const ACTIVE_CLASS = 'mobile-menu--active';

const menuInit = () => {
  const menuToggler = document.querySelector<HTMLDivElement>('.header-search__toggler');
  const mobileMenu = document.querySelector<HTMLDivElement>('.mobile-menu');
  const menuBar = mobileMenu.querySelector<HTMLDivElement>('.mobile-menu__bar');

  menuToggler.addEventListener('click', (e) => {
    e.preventDefault();
    mobileMenu.classList.add(ACTIVE_CLASS);
  });

  menuBar.addEventListener('click', (e) => {
    e.preventDefault();
    mobileMenu.classList.remove(ACTIVE_CLASS);
  });
};

export default menuInit;
